module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__extrasize",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Тип расчёта",
      "required": true,
      "name": "type",
      "id": "type",
      "data-vv-as": ' ',
      "error": _vm.errors.first('type')
    },
    model: {
      value: (_vm.extrasize.type),
      callback: function($$v) {
        _vm.$set(_vm.extrasize, "type", $$v)
      },
      expression: "extrasize.type"
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(" Выбрать... ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weight"
    }
  }, [_vm._v(" По весу ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "volume"
    }
  }, [_vm._v(" По объёму ")])]), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Тип наценки",
      "required": true,
      "name": "markup_type",
      "id": "markup_type",
      "data-vv-as": ' ',
      "error": _vm.errors.first('markup_type')
    },
    model: {
      value: (_vm.extrasize.markup_type),
      callback: function($$v) {
        _vm.$set(_vm.extrasize, "markup_type", $$v)
      },
      expression: "extrasize.markup_type"
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(" Выбрать... ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(" Числовая ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v(" Процентная ")])]), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        min_value: 0.01,
        max_value: 9999999999,
        decimal: [2, '.']
      }),
      expression: "{'required': true, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}"
    }],
    attrs: {
      "label": "Величина наценки",
      "name": "markup_value",
      "id": "markup_value",
      "required": true,
      "error": _vm.errors.first('markup_value'),
      "type": "number",
      "data-vv-name": "markup_value",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.extrasize.markup_value),
      callback: function($$v) {
        _vm.$set(_vm.extrasize, "markup_value", $$v)
      },
      expression: "extrasize.markup_value"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        min_value: 0.001,
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}"
    }],
    attrs: {
      "label": "Минимум (кг/м<sup>3</sup>)",
      "name": "min",
      "id": "min",
      "required": true,
      "error": _vm.errors.first('min'),
      "type": "number",
      "data-vv-name": "min",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.extrasize.min),
      callback: function($$v) {
        _vm.$set(_vm.extrasize, "min", $$v)
      },
      expression: "extrasize.min"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        min_value: 0.001,
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}"
    }],
    attrs: {
      "label": "Максимум (кг/м<sup>3</sup>)",
      "name": "max",
      "id": "max",
      "required": true,
      "error": _vm.errors.first('max'),
      "type": "number",
      "data-vv-name": "max",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.extrasize.max),
      callback: function($$v) {
        _vm.$set(_vm.extrasize, "max", $$v)
      },
      expression: "extrasize.max"
    }
  }), _vm._v(" "), _c('z-input-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "property": "id",
      "return": "id",
      "display-property": "name",
      "name": "way_id",
      "id": "way_id",
      "type": "type",
      "placeholder": "Направление*",
      "label": "Направление*",
      "default": _vm.extrasize.way_name,
      "callback": _vm.searchWay,
      "required": true,
      "error": _vm.errors.first('way_id'),
      "data-vv-name": "way_id",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.extrasize.way_id),
      callback: function($$v) {
        _vm.$set(_vm.extrasize, "way_id", $$v)
      },
      expression: "extrasize.way_id"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b57116b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/extrasize/WayFreightExtrasize.vue
// module id = 1112
// module chunks = 0